import type { RawParams } from "@uirouter/react";
import type {
    SavedSearchesDto,
    SavedSearchesItemDto,
    SavedSearchesRow,
} from "app/pages/sales-intelligence/pages/home/types/savedSearchesDto";
import type { CellProps } from "app/pages/sales-intelligence/pages/home/types/table";
import { getSavedSearchesRedirect } from "app/pages/sales-intelligence/pages/home/utils/getSavedSearchesRedirect";
import { CardEventCategory } from "app/pages/sales-intelligence/services/tracking/home-page/types";
import type { ResultsViewModel, ResultsViewModelDeps, ViewModelMetadata } from "../../../types/models";
import { RESULTS_LIMIT } from "../const";

const createSavedSearchesResultsViewModel = ({
    data,
    resultsLimit = RESULTS_LIMIT,
}: ResultsViewModelDeps<SavedSearchesDto>): ResultsViewModel<SavedSearchesRow> => {
    const { searches = [], totalCount = 0 } = data ?? {};

    const listsUnderLimit = searches.slice(0, resultsLimit);
    const resultsCount = listsUnderLimit.length;

    const presentationMetadata: ViewModelMetadata = {
        trackingCategory: CardEventCategory.SavedSearches,
        totalResultsCount: totalCount,

        getNavigationParams(cellProps: CellProps<SavedSearchesItemDto>): [string, RawParams] {
            return getSavedSearchesRedirect(cellProps);
        },
    };

    const enrichListData = (item: SavedSearchesItemDto): SavedSearchesRow => ({
        ...item,
        iconName: "phrases",
    });

    return {
        results: listsUnderLimit.map(enrichListData),

        metadata: presentationMetadata,
        areResultsOverLimit: resultsCount > 0 && resultsCount >= resultsLimit,
    };
};

export default createSavedSearchesResultsViewModel;
